"use client";

import type { TrustBar as TrustBarProps } from "@homeinstead/schemas";

import { FeaturedNewsLogos } from "@homeinstead/ui/components/FeaturedNewsLogos";

export function TrustBar({ label }: Omit<TrustBarProps, "_type">) {
  return <FeaturedNewsLogos className="trust-bar" label={label} />;
}
